<div class="bag-reprint__backdrop">
  <div class="bag-reprint__dialog" role="dialog" aria-modal="true" aria-label="Reprint bag labels">
    <h3>Reprint bag labels</h3>
    <p class="bag-reprint__hint">You'll be asked how many bags each one needs.</p>
    <label class="bag-reprint__printer" *ngIf="needsPrinter">
      Printer
      <select data-test="bag-printer" (change)="choosePrinter($any($event.target).value)">
        <option value="">Choose…</option>
        <option *ngFor="let p of tray.availablePrinters" [value]="p">{{ p }}</option>
      </select>
    </label>
    <div class="bag-reprint__all">
      <button type="button" class="btn btn-sm btn-link" (click)="setAll(true)">All</button>
      <button type="button" class="btn btn-sm btn-link" (click)="setAll(false)">None</button>
    </div>
    <ul class="bag-reprint__list">
      <li *ngFor="let row of rows" [attr.data-bag]="row.bagId">
        <label>
          <input type="checkbox" [(ngModel)]="row.checked" [name]="'bag-' + row.bagId" />
          {{ row.patientName }} <span class="bag-reprint__id">bag {{ row.bagId }}</span>
        </label>
      </li>
    </ul>
    <div class="bag-reprint__actions">
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="print()" [disabled]="printing">Print</button>
    </div>
  </div>
</div>
